<!-- 表格属性  收入&&支出账户 -->
<template>
  <div class='c_date'>
    <span class="c_date-label">日期</span>
    <el-date-picker
      v-model="value1"
      size="mini"
      @change="$emit('change',$event)"
      value-format="yyyy-MM-dd"
      type="date"
      :clearable="false"
      placeholder="选择日期">
    </el-date-picker>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        value1:new Date(),
      }
    },
    methods:{
      setValue (date) {
        this.value1 = date;
        this.$emit("change",date)
      }
    }
  }
</script>

<style lang="less" scoped>
  .c_date {
    &-label {
      color: #666666;
      margin-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/dateTime.vue